import { Link } from 'react-router-dom';
import '../styles/gems.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Gems() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="gems-banner" className="gems-banner">
        <div
          className="m-auto banner-container"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="mb-32">
            <img src="./images/logo-gems.svg" alt="gemslogoimage" className="gems-banner-img" />
          </div>
          <p
            className="fs-md fw-bold mb-24"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="100"
          >
            2050 탄소 중립 실현을 위한 필수 솔루션
          </p>
          <p
            className="fs-base mb-60"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            t-GEMS는 조직의 온실 가스 배출량 데이터를
            <br />
            쉽고 체계적으로 관리할 수 있는 솔루션입니다.
          </p>
          <ul
            className="gems-button"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <li>
              <Link to="/contact?service=gems&no=02" className="btn-outline fw-bold">
                소개자료 문의하기
              </Link>
            </li>
            <li>
              <Link to="/contact?service=gems&no=01" className="btn-filled fw-bold">
                서비스 도입 문의
              </Link>
            </li>
          </ul>
        </div>
      </section>

      <section id="gems-intro">
        <div className="m-auto content-padding">
          <h3 className="gems-content-title02">
            <strong>t-GEMS</strong> 를 사용해야 하는 이유
          </h3>
          <p className="fs-md content-subtitle text-center">
            우리 조직의 모든 사업장에 대한
            <br className="pc-none" /> 온실가스 배출량을 한 곳에서 관리
            <br />
            <br className="pc-none" />
            이제껏 경험해 보지 못했던 쉽고
            <br className="pc-none" /> 편리한 온실가스 배출량 관리 솔루션
          </p>
          <div className="content-bg content-gap reason02-container">
            <div className="content-box gems-boxbar-x reason02-box">
              <ul>
                <li>
                  <p className="fs-base gems-intro-title">모든 운영경계</p>
                  <div className="text-dot-flex">
                    <p className="text-dot color-caption">Scope 1 (직접 배출)</p>
                    <p className="text-dot color-caption">Scope 2 (간점 배출)</p>
                    <p className="text-dot color-caption">Scope 3 (기타 간접 배출)</p>
                  </div>
                </li>
                <li>
                  <p className="fs-base gems-intro-title">기준 정보에서 모두</p>
                  <div className="text-dot-flex">
                    <p className="text-dot color-caption">공통코드, 배출량 계산식</p>
                    <p className="text-dot color-caption">배출계수 (IPCC, 국가고유)</p>
                    <p className="text-dot color-caption">매개변수, 매개변수 그룹</p>
                    <p className="text-dot color-caption">산정등급, GWP, …</p>
                  </div>
                </li>
                <li>
                  <p className="fs-base fw-md">
                    데이터는&nbsp;
                    <br className="mo-none" />
                    연료 사용량만 입력
                  </p>
                  <div className="text-dot-flex">
                    <p className="text-dot color-caption">업체/사업장/배출시설 관리</p>
                    <p className="text-dot color-caption">사업장별 배부 기준</p>
                    <p className="text-dot color-caption">감축목표 설정</p>
                    <p className="text-dot color-caption">배출량 산정 및 현황</p>
                    <p className="text-dot color-caption">배출량 추이 분석</p>
                  </div>
                </li>
                <li>
                  <p className="fs-base gems-intro-title">글로벌 표준에 근거</p>
                  <div className="text-dot-flex">
                    <p className="text-dot color-caption">고정연소, 이동연소</p>
                    <p className="text-dot color-caption">공정배출, 폐기물 관리</p>
                    <p className="text-dot color-caption">간접배출 (외부 전기/스팀)</p>
                    <p className="text-dot color-caption">GHG 프로토콜, IPCC, …</p>
                  </div>
                </li>
                <li>
                  <p className="fs-base gems-intro-title">각종보고서 제공</p>
                  <div className="text-dot-flex">
                    <p className="text-dot color-caption">PDF 기반 보고서</p>
                    <p className="text-dot color-caption">ESG 보고서 연동</p>
                    <p className="text-dot color-caption">CBAM 보고서 연동</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="arrow">
              <img src="./images/gems-arrow.svg" alt="아래화살표" />
            </div>
            <div className="reason02-fin gems-reason-fin fs-md fw-bold">
              t-GEMS와 함께 진정한 탄소중립을 실현
            </div>
          </div>
          <h3 className="gems-content-title">
            <strong>t-GEMS</strong> 만의 특장점
          </h3>
          <div className="content-bg gems-strength-container">
            <div className="content-box gems-strength-box gems-boxbar-y">
              <div className="gems-strength-title">
                <img
                  src="./images/ico-gems-strength01.svg"
                  alt="strength-icon01"
                  className="mb-16"
                />
                <p className="color-gems fs-md fw-bold">
                  탄소 중립 전 과정을&nbsp;
                  <br className="mo-none" />
                  하나의 플랫폼에서
                </p>
              </div>
              <ul className="gems-strength-content">
                <li>
                  <p className="text-dot fs-base">핵심 데이터들 기준 정보에서 통합 관리</p>
                  <p className="text-bar ml-12 mt-4">
                    IPCC 기본 배출계수, 국가 고유 배출계수, GWP, 표준 산정식, 매개변수, 최소산정기준
                    등
                  </p>
                </li>
                <li>
                  <p className="text-dot fs-base">데이터 수집 및 입력 표준화</p>
                  <p className="text-bar ml-12 mt-4">
                    API를 통한 사내 레거시 · 외부 데이터 연동, 활동 데이터 직접 입력, 엑셀 업로드
                  </p>
                </li>
                <li>
                  <p className="text-dot fs-base">
                    국제 표준 기반 솔루션으로 신뢰도 높은 배출량 산정
                  </p>
                  <p className="text-bar ml-12 mt-4">GHG Protocol, IPCC 가이드라인, SBTi</p>
                </li>
                <li>
                  <p className="text-dot fs-base">온실가스 배출량 산정 자동화</p>
                  <p className="text-bar ml-12 mt-4">
                    매개변수 그룹 자동 지정 → 한번의 클릭으로 온실가스 배출량 데이터 산출
                  </p>
                </li>
                <li className="text-dot fs-base">보고서 생성 자동화</li>
                <li className="text-dot fs-base">감축목표 수립 (단기, 중기, 장기) 지원</li>
              </ul>
            </div>
            <div className="content-box gems-strength-box gems-boxbar-y">
              <div className="gems-strength-title">
                <img
                  src="./images/ico-gems-strength02.svg"
                  alt="strength-icon02"
                  className="mb-16"
                />
                <p className="color-gems fs-md fw-bold">차별화된 서비스</p>
              </div>
              <ul className="gems-strength-content">
                <li className="text-dot fs-base">제품별 및 납품사별 배부기준에 의한 배출량 산정</li>
                <li className="text-dot fs-base">
                  모든 산업에 적용 가능한 컴포넌트 기반 모듈 구현
                </li>
                <li className="text-dot fs-base">제 3자 검증을 통합한 Data 적합성 확보</li>
                <li className="text-dot fs-base">
                  다양한 리포트 지원 (CBAM, 정부보고서, 지속가능경영 보고서)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="gems-architecture">
        <div className="m-auto content-padding">
          <h3 className="gems-content-title">
            <strong>t-GEMS</strong> 주요 기능
          </h3>
          <div className="img-gems-img content-gap">
            <img src="./images/img-gems-main.svg" alt="gems-main-function" />
          </div>
          <div className="img-gems-img-mo content-gap">
            <img src="./images/img-gems-main-mo.svg" alt="gems-main-function" />
          </div>
          <h3 className="gems-content-title">
            <strong>t-GEMS</strong> 아키텍쳐
          </h3>
          <div className="img-gems-img">
            <img src="./images/img-gems-architecture.svg" alt="gems-architecture" />
          </div>
          <div className="img-gems-img-mo">
            <img src="./images/img-gems-architecture-mo.svg" alt="gems-architecture" />
          </div>
        </div>
      </section>
      <section id="uxboard-effect">
        <div className="m-auto content-padding">
          <h3 className="gems-content-title">
            <strong>t-GEMS</strong> 도입 기대효과
          </h3>
          <div className="gems-effect-container">
            <div className="content-box gems-effect-box">
              <div className="gems-effect-title">
                <p className="color-gems fs-md fw-bold">탄소 데이터 누락 방지</p>
              </div>
              <ul className="gems-effect-text">
                <li className="fs-base">데이터 오류/누락 가능성 제거</li>
                <li className="fs-base">사업장/담당자별 필요 데이터 집계 방식 표준 제공</li>
                <li className="fs-base">국내외 등 다수 사업장에 대한 효울적 관리</li>
              </ul>
            </div>
            <div className="content-box gems-effect-box">
              <div className="gems-effect-title">
                <p className="color-gems fs-md fw-bold">온실가스 배출량 데이터 정합성 보장</p>
              </div>
              <ul className="gems-effect-text">
                <li className="fs-base">사업장/담당자별 탄소 배출량 산출방식 동일 적용</li>
                <li className="fs-base">
                  사업장/배출시설, 배출활동, 산정식, 활동자료 및 계수의 표준화
                </li>
                <li className="fs-base">산출결과에 대한 정합성 제공</li>
              </ul>
            </div>
            <div className="content-box gems-effect-box">
              <div className="gems-effect-title">
                <p className="color-gems fs-md fw-bold">제3자 검증 신속성 및 정확성 확보</p>
              </div>
              <ul className="gems-effect-text">
                <li className="fs-base">데이터 원천, 산출과정 등 이력관리</li>
                <li className="fs-base">데이터 산출내역/증빙 등 DB에 통합 저장</li>
                <li className="fs-base">회사 조직 변경 시 산출이력 및 노하우 유지</li>
                <li className="fs-base">데이터 취합, 배출량 산정, 검증에 신속성 제공</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="gems-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img src="./images/logo-gems-white.svg" alt="gems-logo" className="pb-8" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=gems&no=01" className="color-gems">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Gems;
